import { makeStyles } from 'tss-react/mui';

export const useStyles = makeStyles()(() => ({
  headerCell: {
    fontWeight: 'bold',
    fontSize: 15,
    color: '#858585',
  },
}));
